import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from 'tss-react/mui';
import { Paper } from "@mui/material";

// A card of the My Profile page: a header with an icon, a title, an optional
// explanation and an optional control on the right, then the fields.

const useStyles = makeStyles()((theme) => ({
  card: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    margin: "0 !important",
    borderRadius: 12,
    overflow: "hidden",
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    minHeight: 64,
    padding: theme.spacing(1.5, 2, 1.5, 2.5),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  icon: {
    flexShrink: 0,
    width: 36,
    height: 36,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.tone.brand.main,
    backgroundColor: theme.palette.tone.brand.soft,
    "& svg": {
      fontSize: 19,
    },
  },
  text: {
    flex: 1,
    minWidth: 0,
  },
  title: {
    fontSize: 16,
    fontWeight: 500,
    lineHeight: 1.4,
    color: theme.palette.text.primary,
  },
  hint: {
    fontSize: 12.5,
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
  },
  body: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2.5),
    padding: theme.spacing(2.5),
    // An empty field shows a light hint, with its label above it.
    "& .MuiInputBase-input::placeholder": {
      fontSize: "0.85em",
      color: theme.palette.text.disabled,
      opacity: 1,
    },
  },
}));

const SettingsCard = ({ icon, title, hint, action, children }) => {
  const { classes } = useStyles();
  return (
    <Paper className={classes.card}>
      <div className={classes.header}>
        {icon && <span className={classes.icon}>{icon}</span>}
        <div className={classes.text}>
          <div className={classes.title}>{title}</div>
          {hint && <div className={classes.hint}>{hint}</div>}
        </div>
        {action}
      </div>
      <div className={classes.body}>{children}</div>
    </Paper>
  );
};

SettingsCard.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.node.isRequired,
  hint: PropTypes.node,
  action: PropTypes.node,
  children: PropTypes.node,
};

export default SettingsCard;
